export default "__VITE_ASSET__3875d8d1__"